/* src/app/components/submission-substances-warnings/submission-substances-warnings.component.scss */
/*# sourceMappingURL=submission-substances-warnings.component.css.map */
